import Image from 'next/image';
import Link from 'next/link';
import FullWidthContainer from '../FullWidthContainer';
import appconfig from '@/utils/appConfig';
import { FOOTER_QUERYResult, COMPANY_DETAILS_QUERYResult } from 'sanity.types';

const Footer = ({
    footerData,
    companyDetails,
}: {
    footerData: FOOTER_QUERYResult;
    companyDetails: COMPANY_DETAILS_QUERYResult;
}) => {
    const componentClasses = `p-4 pt-0 flex flex-col justify-between ${appconfig.maxSiteWidth} w-full font-bold text-md font-lato`;
    const currentYear = new Date().getFullYear();

    const { logoUrl, logoAlt } = companyDetails?.[0] || {};

    return (
        <FullWidthContainer light>
            <footer className={componentClasses}>
                <section className="mx-auto w-full max-w-site px-6 md:px-0 mt-auto pt-6 md:pt-12 pb-8">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-0 text-center sm:text-left">
                        <div className="flex flex-col items-center sm:items-start">
                            <div className="flex items-center gap-2 mb-4">
                                <Link
                                    href="/"
                                    className="flex ml-4 md:mx-0 md:mr-16"
                                >
                                    <Image
                                        unoptimized={true}
                                        src={logoUrl as string}
                                        alt={(logoAlt as string) || ''}
                                        className="max-w-[260px]"
                                        height={56}
                                        width={184}
                                        style={{ width: 'auto' }}
                                        priority
                                    />
                                </Link>
                            </div>
                            <p className="text-sm text-gray-950 leading-relaxed font-body">
                                Affordable, family run car hire based in
                                Virginia Water, serving Egham, Englefield Green,
                                and surrounding areas. Reliable local car rental
                                with no hidden fees.
                            </p>
                        </div>
                        <div className="flex flex-col items-center sm:items-end">
                            <div className="flex flex-col text-center">
                                <h3 className="font-semibold text-black text-xl underline decoration-2 decoration-[#A3C159] underline-offset-4 mb-4">
                                    {footerData?.columns?.[0].title}
                                </h3>
                                <nav aria-label="Information">
                                    <ul className="space-y-2">
                                        {footerData?.columns?.[0]?.links
                                            ? footerData?.columns?.[0]?.links
                                                  .filter(
                                                      (link) =>
                                                          link.active !== false
                                                  )
                                                  .map((link) => (
                                                      <li key={link._key}>
                                                          <a
                                                              className="text-sm text-gray-950 font-body focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black rounded hover:underline hover:decoration-2 hover:decoration-[#A3C159]"
                                                              href={
                                                                  link.path as string
                                                              }
                                                              target={
                                                                  link.openInNewTab
                                                                      ? '_blank'
                                                                      : '_self'
                                                              }
                                                              rel={
                                                                  link.openInNewTab
                                                                      ? 'noopener noreferrer'
                                                                      : undefined
                                                              }
                                                              aria-label={
                                                                  link.ariaLabel as string
                                                              }
                                                          >
                                                              {link.label}
                                                          </a>
                                                      </li>
                                                  ))
                                            : null}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    className={`flex flex-col sm:flex-row justify-between text-center ${appconfig.maxSiteWidth} w-full border-t border-gray-200 pt-6`}
                >
                    <h6 className="text-sm">{`Penny Car Hire \u00A9 ${currentYear}`}</h6>
                    <h6 className="text-sm">
                        Site by <Link href="https://www.uicreatives.com" target="_blank" className="underline">UI Creatives</Link> and{' '}
                        <Link
                            href="https://twovo.co.uk"
                            target="_blank"
                            className="underline"
                        >
                            Twovo
                        </Link>
                    </h6>
                </section>
            </footer>
        </FullWidthContainer>
    );
};

export default Footer;
